/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetUsersProfileWebim200, GetUsersProfileWebim400, GetUsersProfileWebimQueryResponse } from '../entities/GetUsersProfileWebim'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1GetWebimVisitorResponseSchema } from './v1/getWebimVisitorResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getUsersProfileWebim200Schema = z.lazy(() => v1GetWebimVisitorResponseSchema) as unknown as ToZod<GetUsersProfileWebim200>

/**
 * @description Bad Request
 */
export const getUsersProfileWebim400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetUsersProfileWebim400>

export const getUsersProfileWebimQueryResponseSchema = z.lazy(() => getUsersProfileWebim200Schema) as unknown as ToZod<GetUsersProfileWebimQueryResponse>